import getLogger from '@ignitesales/logger-es';

const logger = getLogger({ module: 'validateQuestionGroup' });

const validateQuestionGroup = (questionGroup, answers) => {
  let errors;
  const vv = questionGroup.validations || [];

  for (let v of vv) {
    switch (v.type) {
      case 'required': {
        if (!questionGroup.questions.filter(q => Object.prototype.hasOwnProperty.call(answers, q.appkey) && q.type.toLowerCase() !== 'calculated').length) {
          errors = {
            [v.type]: []
          };
        }
        break;
      }
      case 'between': {
        const value = questionGroup.questions.filter(q => Object.prototype.hasOwnProperty.call(answers, q.appkey) && q.type.toLowerCase() === 'number').reduce( (t, curr) => {
          return t + answers[curr.appkey].value;
        }, 0);
        if (value < v.min || value > v.max) {
          errors = {
            [v.type]: [v.min, v.max]
          };
        }
        break;
      }
      default: {
        logger.warn(`Unknown question group validation type ${v.type}`);
      }
    }
  }

  return errors;
};

export default validateQuestionGroup;
